// Xem trước danh sách dán / tên file ảnh vé trước khi gửi lên server.
// Luật bóc UID CHÉP từ hp-media-server-staging/src/gala/lib/guest-parse.ts (normalizeUid, splitLine,
// uidFromFilename): UID = 15–20 chữ số sau khi bỏ "@" đầu và mọi khoảng trắng. Sửa bên đó thì sửa ở đây.

const UID_RE = /^\d{15,20}$/;

/** Bỏ `@` đầu, mọi khoảng trắng; hợp lệ thì trả chuỗi số, không thì null. */
export function normalizeUid(raw: string): string | null {
  const s = String(raw ?? '')
    .trim()
    .replace(/^@/, '')
    .replace(/\s+/g, '');
  return UID_RE.test(s) ? s : null;
}

/** Ô đầu của dòng: tách theo dấu phân cách đầu tiên có mặt (tab, rồi phẩy, rồi `|`). */
function firstCell(line: string): string {
  const sep = ['\t', ',', '|'].find((s) => line.includes(s));
  return (sep ? line.split(sep)[0] : line).trim();
}

export interface PastePreview {
  /** Số dòng có chữ (dòng trống không tính). */
  total: number;
  /** Số dòng bóc được UID. */
  valid: number;
  /** Số dòng GỐC (từ 1, tính cả dòng trống) không bóc được UID. */
  invalid: number[];
}

/** Đếm "Nhận diện N/M dòng" ngay khi gõ, cùng luật với server. */
export function previewPaste(text: string): PastePreview {
  let total = 0;
  let valid = 0;
  const invalid: number[] = [];
  String(text ?? '')
    .split('\n')
    .forEach((raw, i) => {
      const line = raw.replace(/\r$/, '');
      if (line.trim() === '') return;
      total += 1;
      if (normalizeUid(firstCell(line)) !== null) valid += 1;
      else invalid.push(i + 1);
    });
  return { total, valid, invalid };
}

/**
 * Tên file ảnh vé đặt theo UID: `<UID>.png`, `<UID>-ve.PNG`, `<UID>_2.jpg`.
 * Chỉ nhận dãy số đứng đầu tên (sau khi bỏ thư mục và đuôi file).
 */
export function uidFromFilename(name: string): string | null {
  const base = String(name ?? '')
    .split(/[/\x5c]/) // dấu / hoặc dấu gạch chéo ngược (\x5c)
    .pop()
    ?.replace(/\.[^.]*$/, '') ?? '';
  const m = /^(\d+)(?:[-_].*)?$/.exec(base);
  return m ? normalizeUid(m[1]) : null;
}

/** Các tên file KHÔNG bóc được UID (hiện đỏ trước khi gửi, server sẽ bỏ qua các file này). */
export function filesWithoutUid(names: string[]): string[] {
  return names.filter((n) => uidFromFilename(n) === null);
}
